import { render, staticRenderFns } from "./ActiveContractCard.vue?vue&type=template&id=b32d1a40&scoped=true"
import script from "./ActiveContractCard.vue?vue&type=script&lang=js"
export * from "./ActiveContractCard.vue?vue&type=script&lang=js"
import style0 from "./ActiveContractCard.vue?vue&type=style&index=0&id=b32d1a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32d1a40",
  null
  
)

export default component.exports